/* bb-bundle-async.js
   Repli IA pour la boîte "Souvent acheté ensemble".

   Quand aucun produit complémentaire n'est curé dans Search & Discovery, le snippet
   bb-bundle.liquid rend un <bb-bundle-async> à la place de la boîte. Cet élément va
   chercher les recommandations Shopify "related" (re-render de main-product via la
   route product_recommendations) et injecte le <bb-bundle> obtenu dans le formulaire.

   Le <bb-bundle> injecté s'auto-câble : son connectedCallback (bb-bundle.js) lit son
   JSON et retrouve le formulaire via closest('form').
*/

(function () {
  if (window.customElements && customElements.get('bb-bundle-async')) return;

  class BbBundleAsync extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.load();
    }

    async load() {
      const url = this.dataset.url;
      if (!url) {
        this.remove();
        return;
      }

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const bundle = tmpl.content.querySelector('bb-bundle');

        // On n'injecte que si le re-render a produit une boîte avec au moins une ligne.
        if (bundle && bundle.querySelector('[data-bb-bundle-item]')) {
          // outerHTML re-parse dans le formulaire parent et upgrade le <bb-bundle>,
          // qui se câble alors tout seul (cf. product-recommendations.js).
          this.outerHTML = bundle.outerHTML;
        } else {
          this.remove();
        }
      } catch (error) {
        this.remove();
        console.log(error); // eslint-disable-line
      }
    }
  }

  customElements.define('bb-bundle-async', BbBundleAsync);
})();
